import {connect} from "react-redux";
import UserCreditLimit from "./List";
import {bindActionCreators} from "redux";
import {getUserCreditLimit} from "../../../../services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
    userCreditLimit: state.MaterialRequistionForm.userCreditLimit
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getUserCreditLimit
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UserCreditLimit);
